import { createComponent } from '@bigyouth/base'

import './style/styles-occasions.scss'
import './features/occasionsFiltersModal'
import './features/occasionsFiltersRecap'
import * as features from './features/exports/occasions'

Object.values(features).forEach(createComponent)
